<template>
  <div>
    <div v-show="visible.video">
      <unit-title title="监控信息" />
      <div class="monitor-box no-border">
        <div class="title">
          良心生产，不怕监督，24小时视频监控
        </div>
        <monitor-video :visible.sync="visible.video" :user-id="userId" />
      </div>
    </div>
    <div v-show="visible.sensor">
      <div class="label">
        环境监控:
      </div>
      <sensor-list :visible.sync="visible.sensor" :user-id="userId" />
    </div>
  </div>
</template>

<script>
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import MonitorVideo from '@/views/productManage/TraceSource/components/MonitorVideo'
import SensorList from '@/views/productManage/TraceSource/components/SensorList'

export default {
  name: 'FarmLandIotDevice',
  components: { SensorList, MonitorVideo, UnitTitle },
  props: {
    userId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      visible: {
        video: false,
        sensor: false
      }
    }
  }
}
</script>

<style lang='less' scoped>
.monitor-box {
  border-bottom: 1px solid #d6d6d6;
  padding-bottom: 30px;
  .title {
    text-align: center;
    padding: 30px 0;
    font-size: 12px;
    color: #0088FF;
  }
}
</style>
